<template lang="pug">
  section
    b-container
      h1 RENTALS
      //- b-form-group(label="FILTER")
        b-form-checkbox-group(:options="statusOptions", v-model="filter.status", switches, @input="getData()")
      content-loader(:height="7", v-if="alert.loading")
      b-card.table-card(v-else-if="rentals && rentals.length > 0")
        p(v-if='rentals.length < 1') No rentals
        b-table#tblLiveRentals(v-else="", :items="rentals", :fields="fields", sort-icon-left, sort-by="status", :sort-desc="true", responsive, borderless, hover)
          template(v-slot:cell(compStatus)="row")
              b-badge(variant="light") {{ row.item.status }}
      nothing(v-else="")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'Rental',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      rentals: [],
      currentPage: 1,
      polling: null,
      lastUpdate: '',
      fields: [
        { key: 'art_title', label: 'Piece' },
        { key: 'date_start_pretty', label: 'From' },
        { key: 'date_end_pretty', label: 'To' },
        { key: 'compStatus', label: 'Status' },
      ],
      statusOptions: ['active', 'pending'],
      filter: {
        status: ['active'],
      },
    };
  },
  computed: {
    totalRows() {
      return this.rentals.length;
    },
  },
  methods: {
    async getData() {
      try {
        this.loading();
        this.rentals = await apiService.getRentals(this.filter);
        this.clear();
      } catch (error) {
        this.error('Could not fetch items');
      }
    },
  },
  async created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Rentals.vue